import Link from 'next/link'
import { Image } from '@systhemaui/next'
import clsx from 'clsx'

export interface TitleCardProps {
  title: string
  slug: string
  imageUrl: string
  className?: string
}

const TitleCard: React.FC<TitleCardProps> = ({ title, slug, imageUrl, className }) => {
  return (
    <Link
      href={`/musor/${slug}`}
      className={clsx(
        'library-card group/library-card relative isolate block aspect-16/9 overflow-hidden transition-shadow duration-300',
        className,
      )}
    >
      <Image
        className="absolute inset-0 aspect-auto h-full w-full transition-opacity duration-300 group-hover/library-card:opacity-60"
        src={imageUrl}
        alt={title}
        objectFit="cover"
        loading="lazy"
        decoding="async"
        fetchPriority="low"
        sizes="(max-width: 640px) 50vw, (max-width: 768px) 33vw, 25vw"
        disableAnimation
      />
      <span className="sr-only!">{title}</span>
    </Link>
  )
}

export default TitleCard
